{
  "services": {
    "sidebar": {
      "close": "",
      "select": {
        "bound": "",
        "flight": "",
        "select": ""
      }
    }
  }
}
